import { isAnyOf } from '@reduxjs/toolkit';

import { startAppListening } from '@/stores/listener-middleware';

import { alert } from '@nablax/shared/stores';
import { TranslatableError } from '@nablax/shared/types';
import { createProjectFile, exitEditor } from './project.actions';
import { selectAllSTLFiles } from './project.selectors';
import {
  loadCloudProject,
  loadLocalProject,
  patchProjectFile,
} from './project.thunks';

startAppListening({
  predicate: isAnyOf(loadCloudProject.rejected, loadLocalProject.rejected),
  effect: (action, { dispatch }) => {
    dispatch(
      alert({
        variant: 'danger',
        title: 'alerts.error',
        message:
          (action.error as any).name === TranslatableError.name
            ? (action.error as any).message
            : 'alerts.cloudProjectError',
      }),
    );
  },
});

startAppListening({
  actionCreator: loadLocalProject.fulfilled,
  effect: (_, { dispatch }) => {
    dispatch(
      alert({
        variant: 'info',
        title: 'alerts.info',
        message: 'alerts.isLocalProject',
      }),
    );
  },
});

startAppListening({
  actionCreator: exitEditor,
  effect: (_, api) => {
    const state = api.getOriginalState();
    const stls = selectAllSTLFiles(state);
    for (const stl of stls) {
      URL.revokeObjectURL(stl.objectURL);
    }
  },
});

/**
 * Force syncronization when adding a new file
 * by faking a patchProjectFile and syncing
 */
startAppListening({
  actionCreator: createProjectFile,
  effect: (action, { dispatch }) => {
    dispatch(
      patchProjectFile({
        type: action.payload.type,
        baseName: action.payload.file.baseName,
        patchContent: {},
      }),
    );
  },
});
